import styled, { css } from "styled-components/native";
import { pickStyle as _, pickThemeKey as theme } from "utils";
import {
  ContainerWidth,
  FeedbackButtonWidth,
  ButtonHeight,
  ListTextFontWeight,
  ListTextFontSize,
  ButtonMarginBottom,
} from "./variables";

export const Container = styled.View`
  width: ${_(ContainerWidth) || "100%"};
  align-self: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const ListItem = styled.TouchableOpacity`
  width: ${_(FeedbackButtonWidth) || "180"}px;
  height: ${_(ButtonHeight) || 170}px;
  border-radius: 8px;
  padding: 22px 12px;
  background-color: ${props =>
    props.$isSelected
      ? theme("image_background_selected")(props)
      : theme("image_background")(props)};
  margin: ${_(ButtonMarginBottom) || "0px 15px 30px 15px"};
  justify-content: center;
  align-items: center;
  box-shadow: #0000001a 0px 3px 5px;
  border: 3px
    ${props =>
      props.$isSelected
        ? theme("image_text_selected")(props)
        : theme("image_background")(props)};
`;

export const CoverImage = styled.Image`
  width: 100%;
  height: 60px;
  margin-bottom: 10px;
  filter: opacity(1) drop-shadow(0 0 0);
  ${props =>
    !props.$trueColors &&
    css`
      tint-color: ${p =>
        p.$isSelected
          ? theme("image_selected")(p)
          : theme("image_unselected")(p)};
    `};
`;

export const ListText = styled.Text`
  color: ${props =>
    props.$isSelected
      ? theme("image_text_selected")(props)
      : theme("image_text")(props)};
  font-size: ${_(ListTextFontSize) || theme("image_option_text_size") || 18}px;
  font-weight: ${_(ListTextFontWeight) || 200};
  text-align: center;
`;
